module.exports = __webpack_public_path__ + "static/media/html5.580a57ca.svg";